import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://backend.ems.uk.hiradentallab.com/api/',
});

// Add interceptor to include token and check expiry
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        const expiry = localStorage.getItem('expiry');

        // If token exists and is expired
        if (token && expiry && Date.now() > expiry) {
            // Clear storage and optionally redirect (only works in component, not here)
            localStorage.clear();
            alert('Session expired. Please log in again.');
            window.location.href = '/signin'; // Redirect to signin
            return Promise.reject(new Error('Token expired'));
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default axiosInstance;
